import {
  IonContent,
  IonPage,
  IonButton,
  IonInput,
  IonLabel,
  IonItem,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

import { Link, useHistory } from "react-router-dom";
import { toast } from "../../../components/Toast/toast";
import { loginUser } from "../../../services/auth";
import { loginUserUpdate, setUser } from "../../../services/users";
import { connect } from "react-redux";
import { setLoading } from "../../../services/loading";
import Spacer from "../../../components/spacer";

interface props {
  loggedIn: any;
  setUser: any;
  setLoading: any;
}

const Login: React.FC<props> = ({ loggedIn, setUser, setLoading }) => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (loggedIn) {
      history.replace("/");
    }
    //eslint-disable-next-line
  }, [loggedIn]);

  function login() {
    //console.log("outputting something");
    setLoading(true, "Logging in");
    loginUser({ email, password }).then((res: any) => {
      //console.log("outputting something else");
      if (res) {
        setUser(res);
        loginUserUpdate(res);
        history.replace("/dashboard");
        toast("You are logged in!");
      }
      setLoading(false);
    });
    //console.log("outputting something else altogether");
  }

  if (!loggedIn)
    return (
      <IonPage>
        <IonContent fullscreen className="ion-padding auth-screen">
          <div className="page-wrapper app-background">
            <div id="app-logo" />
            <div id="content-box">
              <h1 className="center-text instructions">Login</h1>
              <IonItem>
                <IonLabel position="floating">Username</IonLabel>
                <IonInput
                  type="email"
                  name="username"
                  inputmode="email"
                  placeholder="Username"
                  autocomplete="username"
                  onIonChange={(e: any) => setEmail(e.target.value)}
                />
              </IonItem>
              <Spacer size="15" />
              <IonItem>
                <IonLabel position="floating">Password</IonLabel>
                <IonInput
                  type="password"
                  placeholder="Password"
                  name="password"
                  enterkeyhint="go"
                  autocomplete="current-password"
                  onIonChange={(e: any) => setPassword(e.target.value)}
                />
              </IonItem>
              <Spacer size="15" />
              <IonButton expand="full" size="large" onClick={login}>
                Login
              </IonButton>
              <Spacer size="15" />
              {/* <div
								onClick={() => history.push("/forgotpassword")}
								className="linked instructions small center-text"
							>
								Forgot your password?
							</div> */}
              <Link
                to="/forgotpassword"
                className="instructions small full-width center-text"
              >
                Forgot your password?
              </Link>
            </div>
          </div>
        </IonContent>
      </IonPage>
    );
  else return null;
};

const mapStateToProps = (state: any) => ({
  loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, { setUser, setLoading })(Login);
